// extracted by mini-css-extract-plugin
export var searchHeader = "_8m-0";
export var searchHeaderDark = "_8m-1";